import React from 'react';

function Warning(props) {
  const { msg } = props;
  if (!msg) {
    return null;
  }

  return (
    <div className="float-action-warning">
      <i className="ui2-icon ui2-icon-warning" />
      <span>{msg}</span>
    </div>
  );
}

export default Warning;
